import { Component, OnInit } from '@angular/core';
import { CommonService } from './services/common.service';
import { TransactionService } from './services/transaction.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'bitssa-ui';

  constructor(public common : CommonService, public transactionService : TransactionService) { }

  ngOnInit(): void {
  }
}
